export const blockIconsTravelHolidayVillageNew = (
	<span className='material-symbols-outlined'>holiday_village</span>
);
